/**
 * AnalyticsRedirect — legacy URL migration component.
 *
 * Redirects the old /analytics?widget=ID pattern to the canonical
 * /widgets/ID/analytics route.  Lives here (not in utils/) because this is a
 * React component, and in its own file (separate from DefaultRedirect) because
 * these serve different concerns:
 * - AnalyticsRedirect: legacy URL migration for a specific known route
 * - DefaultRedirect: auth-aware fallback for any unmatched URL
 *
 * When this legacy route is eventually removed from App.js this file goes with
 * it — having it isolated makes that deletion a one-file change.
 */
import React from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { widgetAnalyticsPath } from "../utils/navigation";
import { ROUTES } from "../config/constants";

/**
 * Redirect old /analytics?widget=ID route to /widgets/ID/analytics.
 * Falls back to the authenticated home if no widget ID is present.
 */
export function AnalyticsRedirect() {
  const [searchParams] = useSearchParams();
  const widgetId = searchParams.get("widget");
  // Validate that widgetId is a positive integer (1–15 digits) before
  // interpolating it into a path.  The 15-digit cap matches the upper bound of
  // a PostgreSQL bigint auto-increment ID and rejects arbitrarily long strings.
  // Non-numeric, absent, and oversized values fall through to the safe default.
  // Note: /^\d{1,15}$/ already rejects null ("") and empty strings, so the
  // separate `widgetId &&` truthy guard is not needed.
  if (/^\d{1,15}$/.test(widgetId)) {
    return <Navigate to={widgetAnalyticsPath(widgetId)} replace />;
  }
  return <Navigate to={ROUTES.AUTHENTICATED_HOME} replace />;
}
